/**
 * Combate: o motor da luta — as cenas, a rodada, a iniciativa, os pontos de ação, a
 * distância, o golpe e a fuga — com as três fontes cruzadas e os conflitos na mesa.
 *
 * <p><b>Esta tela substitui o rascunho antigo de Combate</b> (as três listas vazias de
 * etapas, ações e distâncias) — decisão do Theo, 22/08/2026: "pode apagar o conteúdo e
 * tirar o rascunho". A `ListaEditavel` saiu junto, porque só aquele rascunho a usava; o
 * que o time tinha gravado segue no banco sob a chave `combate`, sem tela.
 *
 * <p>Mesmo padrão das outras páginas de quadros ({@link PaginaEmDuasAbas}): duas abas
 * com documento próprio, índice clicável, macro-títulos, títulos/prosa/tabelas
 * editáveis e ícones. O catálogo de ações fica na página "Ações de combate"; as
 * escadas das condições, em "Condições do Personagem".
 *
 * <p>O conteúdo de fábrica mora em {@link ./conteudoDeCombate}. O que o time gravar
 * vence inteiro.
 */
import { GRUPOS, GRUPOS_S2, SECOES, SECOES_S2, TABELAS, TABELAS_S2 } from './conteudoDeCombate';
import { PaginaEmDuasAbas } from './PaginaEmDuasAbas';
import { PAGINAS } from './rascunhoDeGameDesign';

export function Combate() {
  return (
    <PaginaEmDuasAbas
      beta={{
        chave: PAGINAS.combateResumo,
        tabelas: TABELAS,
        secoes: SECOES,
        grupos: GRUPOS,
        subtitulo:
          'O motor da luta: as cenas, a rodada, os pontos de ação e a distância — e o que ainda está em disputa entre as Mecânicas, o GDD e o código.',
      }}
      season2={{
        chave: PAGINAS.combateSeason2,
        tabelas: TABELAS_S2,
        secoes: SECOES_S2,
        grupos: GRUPOS_S2,
        subtitulo: 'O que ficou para depois: a magia em combate, o crítico por tipo de arma e o PvP.',
      }}
    />
  );
}
